/* assets/promo22.js — the 2+2 promo's badge layer and measurement, one code path
 * for every surface.
 *
 * CARD LABELS (2026-10-05): the cards now come from ONE snippet (snippets/dcard.liquid,
 * plus snippets/product-item.liquid), and both render data-p11="1|0" = the product's
 * all-cases membership, the exact scope the promo22-gate Function frees. This
 * layer only paints the label from that attribute, wherever a card appears
 * (collection grid, search, home rails, load-more pages) - no request per card.
 * The old switch, a handle list from /collections/all-cases/products.json (3 x 250),
 * covered under 1% of the ~100,000-product collection; it stays only as the
 * fallback for cards built in JS without the attribute (the header live search),
 * fetched once those appear. The drawer bar ([data-promo22-state]) is the switch.
 *
 * MEASUREMENT: every aspect flows through window.mfTrackPush as mf_promo_step,
 * which assets/mf-track.js splits into promo:<step> beacon steps - so the
 * server-side add/checkout joins (step_add/step_chk) price every promo
 * touchpoint with zero server changes:
 *   promo:bar_view / promo:bar_click        - announcement bar mentioning 2+2
 *   promo:cards_seen / promo:card_click     - badge layer
 *   promo:pdp_view                          - the PDP promo line rendered
 *   promo:drawer_none|one_more|add_gifts|one_gift|applied - drawer states
 *   promo:cases_1..cases_4                  - cart-depth high-water (cumulative)
 */
(function () {
  'use strict';

  /* 4x2: the OFF arm must neither see nor measure the promo. The deal script
     in the head sets __mfP22 before any defer script runs; adoption to 'on'
     mid-page self-heals on the next navigation. */
  /* 1+1 era (2026-08-30): the layer serves the mf_p11 ON arm. The retired
     2+2 gate stays off for everyone; steps get a p11_ prefix so the frozen
     promo:* series keep their 2+2-era meaning untouched. */
  if (window.__mfP11 !== 'on') { return; }
  var D = document, W = window;

  /* The drawer bar (mini-cart static section, rendered site-wide) is the switch
     signal: no [data-promo22-state] element means the merchant turned the promo
     off in the theme editor - nothing fetches, nothing decorates. The collection
     handle rides the same element so all surfaces share one source. */
  function promoEl() { return D.querySelector('[data-promo22-state]'); }

  function track(step, extra) {
    try {
      if (W.mfTrackPush) {
        var o = { mf_step: 'p11_' + step };
        if (extra) { for (var k in extra) { o[k] = extra[k]; } }
        W.mfTrackPush('mf_promo_step', o);
      }
    } catch (e) {}
  }
  var onceSent = {};
  function trackOnce(step, extra) {
    if (onceSent[step]) { return; }
    onceSent[step] = 1;
    track(step, extra);
  }

  /* What counts as "the promo bar's text": the merchant writes the announcement
     copy freely, so match every framing that has actually shipped - "2+2",
     "BUY2GET2", "cumperi 2 / primești 4". Diacritic-tolerant (ș vs s). */
  var BAR_RE = /1\s*\+\s*1|2\s*\+\s*2|buy\s*[12]\s*get|prime[sșş]ti\s*\d/i;

  /* Cart depth, session-level high-water mark: cases_1..cases_4 are CUMULATIVE
     levels (cases_4 = reached 4 or more), reported once per session, so the
     dashboard reads "sessions that reached depth N" and exact-N = level N minus
     level N+1. The count itself is server-rendered on the drawer bar. */
  var casesMem = 0; /* mirror for storage-blocked contexts, so the ladder cannot
                       re-fire more than once per pageview there */
  function reportCases() {
    /* mfTrackPush missing means track() would silently no-op - advancing the
       stored high-water in that state loses the level for the whole session */
    if (!W.mfTrackPush) { return; }
    var el = promoEl();
    if (!el) { return; }
    var n = parseInt(el.getAttribute('data-promo22-cases') || '0', 10) || 0;
    if (n > 4) { n = 4; }
    var done = casesMem;
    try {
      var st = parseInt(sessionStorage.getItem('p22c') || '0', 10) || 0;
      if (st > done) { done = st; }
    } catch (e) {}
    for (var lvl = done + 1; lvl <= n; lvl++) { track('cases_' + lvl); }
    if (n > done) {
      casesMem = n;
      try { sessionStorage.setItem('p22c', String(n)); } catch (e) {}
    } else { casesMem = done; }
  }

  /* ── the fallback handle list (cards without data-p11 only): the promo collection's
     product handles, cached 30 min. A 404 or an empty list leaves those cards
     unlabelled; it no longer switches anything else off. ── */
  function getHandles(collection) {
    try {
      var c = JSON.parse(sessionStorage.getItem('p22h') || 'null');
      if (c && c.t && c.k === collection && (Date.now() - c.t) < 1800000) { return Promise.resolve(c.h); }
    } catch (e) {}
    /* FALLBACK ONLY (see the header): 3 pages of 250 are a sliver of all-cases'
       ~100,000 products, so a JS-built card past them simply goes unlabelled */
    function page(n) {
      return fetch('/collections/' + collection + '/products.json?limit=250&page=' + n)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return (j.products || []).map(function (p) { return p.handle; }); })
        .catch(function () { return []; });
    }
    return page(1).then(function (h1) {
      if (h1.length < 250) { return h1; }
      return page(2).then(function (h2) {
        var all = h1.concat(h2);
        if (h2.length < 250) { return all; }
        return page(3).then(function (h3) { return all.concat(h3); });
      });
    }).then(function (h) {
      try { sessionStorage.setItem('p22h', JSON.stringify({ t: Date.now(), k: collection, h: h })); } catch (e) {}
      return h;
    });
  }

  var styleDone = false;
  function ensureStyle() {
    if (styleDone) { return; }
    styleDone = true;
    var st = D.createElement('style');
    /* rhode voice: the promo spans the ENTIRE case catalogue, so a black slab on
       every card is a repeated shout that differentiates nothing - a quiet accent
       micro-label in its own row reads as a system, not a sticker. It wraps to a
       second line rather than ending in an ellipsis (2026-10-05: at 390 px the
       old one-line label was cut mid-promise; the copy is also shorter now) */
    st.textContent = '.p22-label{display:block;margin-top:7px;color:var(--accent,#8F00FF);' +
      'font-weight:800;font-size:10px;line-height:1.3;letter-spacing:.08em;text-transform:uppercase;' +
      'text-align:left;' +
      'font-family:var(--ui,"Gabarito",sans-serif);pointer-events:none}' +
      /* a product-item card keeps its own alignment (Focal centres some grids) */
      'product-item .p22-label{text-align:inherit}';
    D.head.appendChild(st);
  }

  /* card labels: a.dcard and product-item cards. The server's data-p11 decides when
     it can (attrOk: the promo collection is all-cases, the collection the snippets
     read); a card without the attribute is decided by the fallback handle set once
     it has loaded (state.set), and reports itself so the caller can fetch it.
     data-p22 marks a decided card - "1" labelled, "0" not - so each card is read
     once however often the observer fires. */
  function decorate(state) {
    ensureStyle();
    var cards = D.querySelectorAll('a.dcard:not([data-p22]), product-item[data-p11]:not([data-p22])');
    var hit = 0, needSet = false;
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      var v = state.attrOk ? c.getAttribute('data-p11') : null;
      var ok;
      if (v === '1' || v === '0') { ok = v === '1'; }
      else if (c.tagName === 'A') {
        if (!state.set) { needSet = true; continue; }
        var m = String(c.getAttribute('href') || '').match(/\/products\/([a-z0-9-]+)/);
        ok = !!(m && state.set[m[1]]);
      } else { continue; }
      c.setAttribute('data-p22', ok ? '1' : '0');
      if (!ok) { continue; }
      var b = D.createElement('span');
      b.className = 'p22-label';
      b.textContent = state.badge;
      /* the dcard is the link itself; a product-item takes it at the end of its meta
         block (title, price, swatches), above any add-to-cart row */
      (c.tagName === 'A' ? c : (c.querySelector('.product-item-meta') || c.querySelector('.product-item__info') || c)).appendChild(b);
      hit++;
    }
    if (hit) { trackOnce('cards_seen', { mf_count: hit }); }
    return needSet;
  }

  function boot() {
    var el = promoEl();
    if (!el) { return; }
    var collection = el.getAttribute('data-promo22-collection') || 'all-cases';
    var badgeText = el.getAttribute('data-promo22-badge') || '2+2';
    /* ── measurement wiring, UNCONDITIONAL: it must not depend on the
       products.json fetch that only the badge layer needs - a 429'd or empty
       collection response must not silence the drawer/bar/depth metrics ── */

    /* second-case picker add (snippets/promo22-bar.liquid one_more state):
       the rhode single-POST pattern - /cart/add.js carries sections so the
       drawer paints from the response with zero extra GETs, then one shared
       /cart.js feeds cart:updated with the full payload (theme.js:6076 and
       custom.js:1324 both need cart.items there - never send them a stub). */
    var pickBusy = false;
    function pickAdd(btn) {
      if (pickBusy) { return; }
      var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!vid) { return; }
      pickBusy = true;
      btn.setAttribute('aria-busy', 'true');
      track('pick_add', { mf_option_value: btn.getAttribute('data-p11-name') || '' });
      /* the drawer-level twin of the PLP weave question: do the mixed-in
         fresh designs earn their slots? */
      if (btn.getAttribute('data-p11-src') === 'new') { track('pick_add_new'); }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: 'mini-cart' })
      }).then(function (r) {
        if (!r.ok) { throw new Error('cart/add.js returned ' + r.status); }
        return r.json();
      }).then(function (data) {
        /* invalidate BEFORE dispatching, or the consumers woken by the dispatch
           cache-hit a pre-add cart (the rhode ordering, product-rhode:3510-3516) */
        if (W.mfCart) { W.mfCart.invalidate(); }
        var painted = !!(data && data.sections && data.sections['mini-cart']);
        if (painted) {
          var known = W.mfCart ? W.mfCart.count() : 0;
          D.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { cart: { item_count: (known || 0) + 1, sections: data.sections } }
          }));
        }
        var load = W.mfCart
          ? W.mfCart.get()
          : fetch('/cart.js').then(function (r2) { return r2.json(); });
        return load.then(function (cart) {
          D.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
          if (!painted) {
            D.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
          }
        });
      }).catch(function (e) {
        try { console.error('[mf] p11 pick add failed', e); } catch (e2) {}
        /* re-enable for a retry; on success the re-render replaces the node */
        btn.removeAttribute('aria-busy');
      }).then(function () { pickBusy = false; });
    }

    /* ── second-case quick configurator: ONE control - the device. Type and
       colour sit on the Full-Shock/Black default the server picked; the tile
       carries the design's brand_products map, so another device resolves
       client-side from /products/<handle>.js. The function frees the pair's
       CHEAPEST the moment the line lands, so the CADOU face is true only when
       the pick costs no more than the cheapest paid case already in the cart
       (cfg.floor, data-p11-floor from snippets/promo22-bar.liquid). Then the
       head shows the CADOU badge alone, no struck price (the c25-era choice).
       A pricier pick shows its own price, a line with what the cart total
       really grows by, and a plain add button - never a CADOU claim on it.
       The panel lives inside the drawer, so a cart re-render clears it
       naturally. ── */
    var cfg = null; /* { name, src, img, vid, price, cents, floor, dev, devices:[{label,handle}], cache:{} } */
    function cfgBox() { return D.querySelector('[data-p11-config]'); }
    function escHtml(x) {
      return String(x == null ? '' : x)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    function parseDevices(str) {
      var out = [], parts = String(str || '').split(','), i, kv, l, h;
      for (i = 0; i < parts.length; i++) {
        kv = parts[i].split('=>');
        if (kv.length !== 2) { continue; }
        l = kv[0].replace(/^\s+|\s+$/g, '');
        h = kv[1].replace(/^\s+|\s+$/g, '');
        if (l && h) { out.push({ label: l, handle: h }); }
      }
      return out;
    }
    function fmtMoney(cents) {
      var n = Math.round(cents / 100);
      try {
        var f = W.themeVariables && W.themeVariables.settings && W.themeVariables.settings.moneyFormat;
        if (f) { return String(f).replace(/\{\{\s*amount[^}]*\}\}/, n).replace(/<[^>]+>/g, ''); }
      } catch (e) {}
      return n + ' lei';
    }
    function renderCfg() {
      var box = cfgBox();
      if (!box || !cfg) { return; }
      var i, d, brand, prevBrand;
      /* free = this pick is the pair's cheaper case (a tie frees the same amount);
         an unknown price or floor never claims it */
      var free = !!(cfg.vid && cfg.cents > 0 && cfg.floor > 0 && cfg.cents <= cfg.floor);
      var h = '<div class="promo22__cfg-head">' +
        '<img src="' + escHtml(cfg.img) + '" alt="">' +
        '<span class="promo22__cfg-name">' + escHtml(cfg.name) + '</span>' +
        '<span class="promo22__cfg-price">' +
          (free ? '<span class="promo22__cfg-free">CADOU</span>' : escHtml(cfg.busy ? '…' : (cfg.vid ? cfg.price : ''))) +
        '</span>' +
        '<button type="button" class="promo22__cfg-x" data-p11-cfg-close aria-label="Închide">&times;</button>' +
        '</div>';
      if (cfg.vid && !free) {
        h += '<p class="promo22__cfg-note">' +
          (cfg.floor > 0 && cfg.cents > cfg.floor
            ? 'Totalul crește doar cu ' + escHtml(fmtMoney(cfg.cents - cfg.floor)) + ' — husa mai ieftină e CADOU.'
            : 'Husa mai ieftină e CADOU.') +
          '</p>';
      }
      if (cfg.devices.length > 1) {
        h += '<label class="promo22__cfg-devlab">Telefon</label>';
        h += '<select class="promo22__cfg-dev" data-p11-dev-sel>';
        prevBrand = '';
        for (i = 0; i < cfg.devices.length; i++) {
          d = cfg.devices[i];
          brand = d.label.split(' ')[0];
          if (brand !== prevBrand) {
            if (prevBrand !== '') { h += '</optgroup>'; }
            h += '<optgroup label="' + escHtml(brand) + '">';
            prevBrand = brand;
          }
          h += '<option value="' + escHtml(d.handle) + '"' + (d.label === cfg.dev ? ' selected' : '') + '>' + escHtml(d.label) + '</option>';
        }
        if (prevBrand !== '') { h += '</optgroup>'; }
        h += '</select>';
      }
      h += '<button type="button" class="promo22__cfg-add" data-p11-pick-add' +
        (cfg.vid ? ' data-variant-id="' + cfg.vid + '"' : ' disabled') +
        ' data-p11-src="' + escHtml(cfg.src) + '" data-p11-name="' + escHtml(cfg.name) + '">' +
        (cfg.busy ? '…' : (cfg.vid ? (free ? 'Adaugă — a 2-a husă e CADOU' : 'Adaugă în coș') : 'Indisponibil pe acest telefon')) +
        '</button>';
      box.innerHTML = h;
      box.hidden = false;
    }
    /* Full-Shock Black > Full-Shock any > first available - the same chain the
       server walks (snippets/promo22-bar.liquid) */
    function pickVariant(product) {
      var vs = (product && product.variants) || [];
      var pref = null, fsAny = null, anyAvail = null, fsLine = false, fsBase = null, i, v, vb;
      for (i = 0; i < vs.length; i++) {
        v = vs[i];
        vb = String(v.option1 || '').replace(' MagSafe', '').replace(' Transparent', '');
        if (vb === 'Full-Shock') { fsLine = true; }
        if (!v.available) { continue; }
        if (vb === 'Full-Shock' && !fsBase) { fsBase = v; }
        if (!anyAvail) { anyAvail = v; }
        if (v.option1 === 'Full-Shock') {
          if (!fsAny) { fsAny = v; }
          if (v.option2 === 'Black' && !pref) { pref = v; }
        }
      }
      /* PDP test arm B sells Full-Shock only: a device whose Full-Shock is sold out
         has no pick (the configurator shows it unavailable) */
      if (W.__mfPDP === 'b' && fsLine) { return pref || fsAny || fsBase || null; }
      return pref || fsAny || anyAvail || null;
    }
    /* GLOSSY + SLIM (owner 2026-10-06): /products/<handle>.js carries the ADMIN price, the cart transform charges
       the glossy 264 / 284 and the paired matt Full-Shock* x0.9 - the rule and its lists come from the drawer
       ([data-p11-gp], snippets/mf-glossy-price.liquid mode 'js'), the same test line by line, so the quoted price
       and the CADOU test below speak the charge. No config (or the switch off) -> the price itself. */
    function gpCents(p, v) {
      var c = v.price, R = null, el = D.querySelector('[data-p11-gp]');
      try { R = JSON.parse(el.textContent); } catch (e) { return c; }
      var h = String((p && p.handle) || ''), at = h.lastIndexOf('-iphone-');
      if (!R || R.on !== true || at < 1 || !(c > 0)) { return c; }
      var dev = h.slice(at + 1), st = h.slice(0, at), t = 0;
      if (String(R.d).indexOf(' ' + dev + ' ') < 0) { return c; }
      var u = dev.indexOf('iphone-17') === 0 ? 28400 : 26400;
      if (st.slice(-7) === '-glossy') {
        if ((p.tags || []).indexOf('Glossy') !== -1 && String(R.g).indexOf(' ' + st.slice(0, -7) + ' ') !== -1) { t = u; }
      } else if (String(R.m).indexOf(' ' + st + ' ') !== -1 && String(v.title || '').indexOf('Full-Shock') === 0 && c >= u) {
        t = Math.floor((Math.round(c) * 9 + 500) / 1000) * 100;
      }
      return t > 0 && t < c ? t : c;
    }
    function applyPick(pick) {
      if (!cfg) { return; }
      cfg.busy = false;
      cfg.vid = pick.vid;
      cfg.price = pick.price;
      cfg.cents = pick.cents || 0;
      renderCfg();
    }
    function resolveDevice(handle) {
      if (!cfg) { return; }
      if (cfg.cache[handle]) { applyPick(cfg.cache[handle]); return; }
      cfg.busy = true;
      cfg.vid = 0;
      cfg.price = '';
      cfg.cents = 0;
      renderCfg();
      fetch('/products/' + handle + '.js')
        .then(function (r) {
          if (!r.ok) { throw new Error('product ' + r.status); }
          return r.json();
        })
        .then(function (p) {
          var v = pickVariant(p);
          var gc = v ? gpCents(p, v) : 0;
          var pick = v ? { vid: v.id, price: fmtMoney(gc), cents: gc } : { vid: 0, price: '', cents: 0 };
          cfg.cache[handle] = pick;
          applyPick(pick);
        })
        .catch(function () { applyPick({ vid: 0, price: '', cents: 0 }); });
    }
    function openCfg(btn) {
      var devs = parseDevices(btn.getAttribute('data-p11-devices'));
      var dev = btn.getAttribute('data-p11-dev') || '';
      var vid = parseInt(btn.getAttribute('data-p11-default'), 10) || 0;
      var price = btn.getAttribute('data-p11-price') || '';
      var cents = parseInt(btn.getAttribute('data-p11-cents'), 10) || 0;
      var strip = btn.closest('[data-p11-pick]');
      cfg = {
        name: btn.getAttribute('data-p11-name') || '',
        src: btn.getAttribute('data-p11-src') || '',
        img: btn.getAttribute('data-p11-img') || '',
        vid: vid,
        price: price,
        cents: cents,
        floor: (strip && parseInt(strip.getAttribute('data-p11-floor'), 10)) || 0,
        dev: dev,
        devices: devs,
        busy: false,
        cache: {}
      };
      /* seed the cache so flipping back to the cart's device costs no fetch */
      for (var i = 0; i < devs.length; i++) {
        if (devs[i].label === dev) { cfg.cache[devs[i].handle] = { vid: vid, price: price, cents: cents }; break; }
      }
      track('pick_open', { mf_option_value: cfg.name });
      if (cfg.src === 'new') { track('pick_open_new'); }
      renderCfg();
    }
    D.documentElement.addEventListener('change', function (ev) {
      var sel = ev.target && ev.target.closest && ev.target.closest('[data-p11-dev-sel]');
      if (!sel || !cfg) { return; }
      var opt = sel.options[sel.selectedIndex];
      cfg.dev = opt ? (opt.textContent || '') : '';
      track('pick_dev_change');
      resolveDevice(sel.value);
    }, true);

    /* desktop drag-to-scroll for the tile strip; touch scrolls natively. The
       dragMoved flag suppresses the click that follows a drag, so a drag never
       opens the configurator by accident. */
    var dragMoved = false;
    D.documentElement.addEventListener('pointerdown', function (ev) {
      if (ev.pointerType === 'touch') { return; }
      var strip = ev.target && ev.target.closest && ev.target.closest('[data-p11-pick]');
      if (!strip) { return; }
      var sx = ev.clientX;
      var sl = strip.scrollLeft;
      dragMoved = false;
      function onMove(e2) {
        var dx = e2.clientX - sx;
        if (dx > 5 || dx < -5) { dragMoved = true; }
        strip.scrollLeft = sl - dx;
        e2.preventDefault();
      }
      function onUp() {
        W.removeEventListener('pointermove', onMove, true);
        W.removeEventListener('pointerup', onUp, true);
        setTimeout(function () { dragMoved = false; }, 0);
      }
      W.addEventListener('pointermove', onMove, true);
      W.addEventListener('pointerup', onUp, true);
    }, true);

    /* one delegated click listener serves both surfaces; [data-p22="1"] only
       exists on a labelled card (the dcard link itself, or a product-item around
       its links), so card_click self-gates */
    D.documentElement.addEventListener('click', function (ev) {
      if (!ev.isTrusted) { return; }
      var po = ev.target && ev.target.closest && ev.target.closest('[data-p11-pick-open]');
      if (po) {
        if (!dragMoved) { openCfg(po); }
        return;
      }
      var cx = ev.target && ev.target.closest && ev.target.closest('[data-p11-cfg-close]');
      if (cx) {
        var bx = cfgBox();
        if (bx) { bx.hidden = true; bx.innerHTML = ''; }
        cfg = null;
        return;
      }
      var pk = ev.target && ev.target.closest && ev.target.closest('[data-p11-pick-add]');
      if (pk) { pickAdd(pk); return; }
      var a = ev.target && ev.target.closest && ev.target.closest('a[data-p22="1"], product-item[data-p22="1"] a');
      if (a) { track('card_click'); }
      /* the close button is dismissal, not interest - it must not count */
      if (ev.target && ev.target.closest && ev.target.closest('.glossy-announcement__close')) { return; }
      var bar = ev.target && ev.target.closest && ev.target.closest('.announcement-bar, [class*="announcement"]');
      if (bar && BAR_RE.test(bar.textContent || '')) { track('bar_click'); }
      /* manual drawer opens fire no cart:refresh - a deferred read catches the
         picker exposure (and any state edge) on those paths too */
      setTimeout(readDrawer, 700);
    }, true);

    /* the FIRST announcement-ish element in document order is Focal's empty
       section wrapper (its textContent is CSS) - scan them ALL and skip
       dismissed bars, or bar_view never fires while bar_click does */
    var anns = D.querySelectorAll('.announcement-bar, [class*="announcement"]');
    for (var ai = 0; ai < anns.length; ai++) {
      if (anns[ai].classList.contains('is-hidden')) { continue; }
      if (BAR_RE.test(anns[ai].textContent || '')) { trackOnce('bar_view'); break; }
    }

    /* PDP promo line */
    if (D.querySelector('[data-promo22-pdp]')) { trackOnce('pdp_view'); }

    /* drawer progress states + cart depth: read after every server re-render.
       The glossy add path re-renders the drawer only after an awaited
       /cart?section_id=mini-cart round-trip, so 600ms can be too early on slow
       connections - a second read catches the late swap. */
    var lastState = '';
    function readDrawer() {
      /* the load-time gate above reads __mfP11 once; price-tier.js adoptArm
         drops mf-p11-on when this pageview adopts a non-1+1 cart (q72), and
         from then on no drawer_* / pick_view / cases_* step may fire */
      if (!D.documentElement.classList.contains('mf-p11-on')) { return; }
      var el = D.querySelector('[data-promo22-state]');
      if (!el) { return; }
      var stt = el.getAttribute('data-promo22-state') || '';
      if (stt && stt !== lastState) {
        lastState = stt;
        track('drawer_' + stt);
      }
      /* picker exposure: the drawer exists CSS-hidden on every page, so
         presence alone would count pageviews - only a visible picker counts
         (the custom.js fol:resc_shown gate, custom.js:1443-1446) */
      var pick = D.querySelector('[data-p11-pick]');
      if (pick && pick.offsetWidth > 0 && getComputedStyle(pick).visibility !== 'hidden') {
        trackOnce('pick_view');
      }
      reportCases();
    }
    readDrawer();
    D.documentElement.addEventListener('cart:refresh', function () {
      setTimeout(readDrawer, 600);
      setTimeout(readDrawer, 1800);
    }, false);

    /* ── badge layer: server-decided cards first; the handle list only when a card
       arrives without data-p11 (an empty or failed list leaves those unlabelled) ── */
    var lab = { badge: badgeText, attrOk: collection === 'all-cases', set: null };
    var setAsked = false;
    function runLabels() {
      if (!decorate(lab) || setAsked) { return; }
      setAsked = true;
      getHandles(collection).then(function (handles) {
        var set = {};
        (handles || []).forEach(function (h) { set[h] = 1; });
        lab.set = set;
        decorate(lab);
      });
    }
    runLabels();
    /* load-more and drawer re-renders inject new cards; a light debounce keeps
       the observer from thrashing during the drawer's innerHTML swaps */
    var t = null;
    new MutationObserver(function () {
      if (t) { clearTimeout(t); }
      t = setTimeout(runLabels, 400);
    }).observe(D.body, { childList: true, subtree: true });
  }

  /* Defer scripts evaluate at readyState 'interactive', BEFORE DOMContentLoaded
     fires - and this file loads ahead of mf-track.js in the defer queue. Booting
     synchronously here would run the warm-cache (sessionStorage) path in a
     microtask while window.mfTrackPush does not exist yet, silently dropping
     every step fired at boot. DOMContentLoaded fires only after ALL defer
     scripts have executed, so waiting for it guarantees the tracker is up. */
  if (D.readyState === 'complete') { boot(); }
  else { D.addEventListener('DOMContentLoaded', boot, false); }
})();
